// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"220":"cb0fee09","7944":"ccd0c233"}[chunkId] + ".chunk.css";
};